const resource = {
    resource_identifier_in_use: 'O identificador da API {{indicator}} já está em uso',
    cannot_delete_management_api: 'Não é possível excluir a API de gestão do Logto.',
    cannot_modify_management_api: 'Não é possível modificar a API de gestão do Logto.',
};
export default Object.freeze(resource);
